<ion-header>
    <ion-toolbar color="primary">
        <ion-title>{{ amvm.title }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- <ion-radio-group [(ngModel)]="amvm.startingSource" (ionChange)="onSourceChange()" data-test="sourceGroup">
        <ion-item>
            <ion-radio slot="start" value="dealership" data-test="dealership">
            </ion-radio>
            <ion-label class="ion-text-wrap">
                {{amvm.optionLabel1}}
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-radio slot="start" value="customLocation" data-test="customLocation">
            </ion-radio>
            <ion-label class="ion-text-wrap">
                {{amvm.optionLabel2}}
            </ion-label>
        </ion-item>
    </ion-radio-group> -->

    <ion-radio-group 
        [ngModel]="amvm.position === 'start' ? amvm.startingSource : amvm.endingSource"
        (ngModelChange)="amvm.position === 'start' ? (amvm.startingSource = $event) : (amvm.endingSource = $event)"
        (ionChange)="onSourceChange()" 
        data-test="sourceGroup">
        
        <ion-item>
            <ion-radio slot="start" value="dealership" data-test="dealership"></ion-radio>
            <ion-label class="ion-text-wrap">{{ amvm.optionLabel1 }}</ion-label>
        </ion-item>
    
        <ion-item>
            <ion-radio slot="start" value="customLocation" data-test="customLocation"></ion-radio>
            <ion-label class="ion-text-wrap">{{ amvm.optionLabel2 }}</ion-label>
        </ion-item>
    </ion-radio-group>


    <ion-list lines="none">
        <ion-item-group>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Location</ion-label>
                <ion-input type="text" [value]="getLocationName()" (ionChange)="setLocationName($event)"
                    [disabled]="isSourceDealership()" data-test="locationName">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Street Address</ion-label>
                <ion-input type="text" [value]="getStreetAddress()" (ionChange)="setStreetAddress($event)"
                    [disabled]="isSourceDealership()" data-test="streetAddress">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">City</ion-label>
                <ion-input type="text" [value]="getCityName()" (ionChange)="setCityName($event)"
                    [disabled]="isSourceDealership()" data-test="cityName">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Zipcode</ion-label>

                <div class="zipcode-container">
                    <ion-input type="text" [value]="getZipcode()" (ionChange)="setZipcode($event)"
                        [disabled]="isSourceDealership()" data-test="zipcode">
                    </ion-input>

                    <!-- (click)="onZipcodeSearchClick()" -->
                    <ion-button fill="solid" color="primary" class="zipcode-search-btn" expand="full"
                        [disabled]="isSourceDealership()" 
                        data-test="zipcodeSearchButton">

                        <ion-icon slot="icon-only" name="search" color="light"></ion-icon>
                    </ion-button>
                </div>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">State</ion-label>
                <ion-input type="text" [value]="getStateName()" (ionChange)="setStateName($event)"
                    [disabled]="isSourceDealership()" data-test="stateName">
                </ion-input>
            </ion-item>

        </ion-item-group>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="medium" expand="full" (click)="onCancelClick()" data-test="cancelButton">
                        Cancel
                    </ion-button>
                </ion-col>

                <ion-col>
                    <ion-button color="secondary" expand="full" [disabled]="isSourceDealership() || !addressDirty"
                        (click)="onVerifyAddressClick()" data-test="verifyButton">
                        Verify Address
                    </ion-button>
                </ion-col>

                <ion-col>
                    <ion-button color="primary" expand="full" [disabled]="!canConfirm()" (click)="onOkayClick()"
                        data-test="okayButton">
                        OK
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>
